import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Button, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { useState } from "react";
import { useMainDashboardLayoutContext } from "../../../context/SuperAdmin/DashboardContexts/MainDashboardLayout";

const HIGHLIGHT_COLOR = "#336B87";
const HIGHLIGHT_DARK = "#2a5a72";

const PickOrg = () => {
  const { selectedOrg, handleChange, orgs } = useMainDashboardLayoutContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSelectOrg = (orgId: string) => {
    handleChange(orgId, `${orgId}/organization`);
    handleMenuClose();
  };

  const getOrgName = (id: string) =>
    orgs.find((org) => org.id_organizacion === id)?.nombre || "Organizations";

  return (
    <Grid container justifyContent="flex-end" spacing={2}>
      <Grid item>
        <Button
          variant={selectedOrg === "organizations" ? "contained" : "outlined"}
          onClick={() => handleChange("organizations", "organizations")}
          sx={{
            borderRadius: "999px",
            textTransform: "none",
            borderColor: HIGHLIGHT_COLOR,
            color: selectedOrg === "organizations" ? "#fff" : HIGHLIGHT_COLOR,
            backgroundColor:
              selectedOrg === "organizations" ? HIGHLIGHT_COLOR : "transparent",
            "&:hover": {
              backgroundColor:
                selectedOrg === "organizations" ? HIGHLIGHT_DARK : "rgba(51,107,135,0.1)",
            },
            py: 1.2,
            px: 3,
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>
            Todos
          </Typography>
        </Button>
      </Grid>

      <Grid item>
        <Button
          variant={selectedOrg !== "organizations" ? "contained" : "outlined"}
          onClick={handleMenuOpen}
          endIcon={<ArrowDropDownIcon />}
          sx={{
            borderRadius: "999px",
            minWidth: 300,
            justifyContent: "space-between",
            textTransform: "none",
            borderColor: HIGHLIGHT_COLOR,
            color: selectedOrg === "organizations" ? HIGHLIGHT_COLOR : "#fff",
            backgroundColor:
              selectedOrg !== "organizations" ? HIGHLIGHT_COLOR : "transparent",
            "&:hover": {
              backgroundColor:
                selectedOrg !== "organizations" ? HIGHLIGHT_DARK : "rgba(51,107,135,0.1)",
            },
            py: 1.2,
            px: 3,
          }}
        >
          <Typography noWrap sx={{ fontSize: "18px", fontWeight: "bold" }}>
            {selectedOrg === "organizations"
              ? "Seleccionar organización"
              : getOrgName(selectedOrg as string)}
          </Typography>
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          {orgs.map((org) => {
            const isSelected = selectedOrg === org.id_organizacion;
            return (
              <MenuItem
                key={org.id_organizacion}
                onClick={() => handleSelectOrg(org.id_organizacion)}
                sx={{
                  fontSize: "16px",
                  backgroundColor: isSelected ? HIGHLIGHT_COLOR : "transparent",
                  color: isSelected ? "#fff" : HIGHLIGHT_COLOR,
                  "&:hover": {
                    backgroundColor: isSelected
                      ? HIGHLIGHT_DARK
                      : "rgba(51,107,135,0.1)",
                  },
                }}
              >
                {org.nombre}
              </MenuItem>
            );
          })}
        </Menu>
      </Grid>
    </Grid>
  );
};

export default PickOrg;
